import React from "react";
import { Card, Col, Row, Statistic } from "antd";
import { CheckCircleOutlined, ClockCircleOutlined, DollarOutlined, RiseOutlined } from "@ant-design/icons";

export default function CardsValores(props) {
  const { valorPago, valorPendente, valorTotal, valorContrato, formatarMoedaBr } = props;

  // Se valorContrato foi passado, calcular saldo em relação ao contrato mãe
  const temContrato = valorContrato != null && valorContrato > 0;
  const saldo = temContrato ? valorContrato - valorPago : null;
  const saldoPositivo = saldo !== null && saldo < 0; // pagou mais do que o contrato

  return (
    <Row gutter={16} style={{ marginBottom: 20 }}>
      {/* Valor Pago */}
      <Col xs={24} sm={8}>
        <Card
          bordered={false}
          style={{
            height: "100%",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            background: "linear-gradient(to right bottom, #ffffff, #f6ffed)",
            borderLeft: "5px solid #52c41a"
          }}
        >
          <Statistic
            title={<span style={{ color: "#555", fontWeight: 600 }}>Valor pago</span>}
            value={valorPago}
            formatter={(val) => formatarMoedaBr(val)}
            valueStyle={{ color: "#3f8600", fontWeight: "bold" }}
            prefix={<CheckCircleOutlined style={{ marginRight: 8 }} />}
          />
        </Card>
      </Col>

      {/* Valor Pendente */}
      <Col xs={24} sm={8}>
        <Card
          bordered={false}
          style={{
            height: "100%",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            background: "linear-gradient(to right bottom, #ffffff, #fff1f0)",
            borderLeft: "5px solid #cf1322"
          }}
        >
          <Statistic
            title={<span style={{ color: "#555", fontWeight: 600 }}>Valor pendente</span>}
            value={valorPendente}
            formatter={(val) => formatarMoedaBr(val)}
            valueStyle={{ color: "#cf1322", fontWeight: "bold" }}
            prefix={<ClockCircleOutlined style={{ marginRight: 8 }} />}
          />
        </Card>
      </Col>

      {/* Valor Total do Contrato / Saldo */}
      <Col xs={24} sm={8}>
        <Card
          bordered={false}
          style={{
            height: "100%",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            background: saldoPositivo
              ? "linear-gradient(to right bottom, #ffffff, #f6ffed)"
              : "linear-gradient(to right bottom, #ffffff, #f0f5ff)",
            borderLeft: saldoPositivo ? "5px solid #52c41a" : "5px solid #2f54eb"
          }}
        >
          {temContrato ? (
            <div>
              <Statistic
                title={<span style={{ color: "#555", fontWeight: 600 }}>Valor do contrato</span>}
                value={valorContrato}
                formatter={(val) => formatarMoedaBr(val)}
                valueStyle={{ color: "#1d39c4", fontWeight: "bold", fontSize: 18 }}
                prefix={<DollarOutlined style={{ marginRight: 8 }} />}
              />
              <div style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 6 }}>
                {saldoPositivo ? (
                  <>
                    <RiseOutlined style={{ color: "#3f8600", fontSize: 14 }} />
                    <span style={{ color: "#3f8600", fontWeight: 600, fontSize: 13 }}>
                      Saldo positivo: {formatarMoedaBr(Math.abs(saldo))}
                    </span>
                  </>
                ) : (
                  <>
                    <ClockCircleOutlined style={{ color: "#1d39c4", fontSize: 14 }} />
                    <span style={{ color: "#1d39c4", fontWeight: 600, fontSize: 13 }}>
                      Falta pagar: {formatarMoedaBr(saldo)}
                    </span>
                  </>
                )}
              </div>
            </div>
          ) : (
            <Statistic
              title={<span style={{ color: "#555", fontWeight: 600 }}>Valor total</span>}
              value={valorTotal}
              formatter={(val) => formatarMoedaBr(val)}
              valueStyle={{ color: "#1d39c4", fontWeight: "bold" }}
              prefix={<DollarOutlined style={{ marginRight: 8 }} />}
            />
          )}
        </Card>
      </Col>
    </Row>
  );
}